<template>
  <v-card
    :color="insideNav ? 'bg_Greeny_Gray' : 'kanban_card_bg_color'"
    class="overflow-hidden d-flex flex-column"
    :class="{ 'h-100': insideNav }"
    :max-height="!insideNav ? '500px' : 'auto'"
    :min-height="!insideNav ? '500px' : 'auto'"
    elevation="0"
    :width="!insideNav ? '30vw' : '100%'"
    :style="{
      borderBottom: userNotifications.length ? `15px solid var(--v-white_GreenyGray-base)` : '',
    }">
    <v-app-bar
      class="flex-grow-0"
      :color="insideNav ? 'bg_Greeny_Gray' : 'kanban_card_bg_color'"
      elevate-on-scroll
      id="notification-list">
      <v-btn
        elevation="0"
        :color="insideNav ? 'bg_Greeny_Gray' : 'bg1'"
        dark
        class="pa-0 me-3"
        min-width="35px"
        height="35px"
        v-if="isPreferences">
        <v-icon :color="insideNav ? 'mid-grey' : 'primary'" @click="resetPreferences()"
          >mdi-arrow-u-left-top</v-icon
        >
      </v-btn>
      <v-btn
        elevation="0"
        color="bg_Greeny_Gray"
        dark
        class="pa-0 me-3"
        min-width="35px"
        height="35px"
        v-if="!isPreferences && insideNav">
        <v-icon :color="insideNav ? 'mid-grey' : 'primary'" @click="closeNotifications()"
          >mdi-arrow-u-left-top</v-icon
        >
      </v-btn>
      <v-spacer v-if="insideNav"></v-spacer>
      <v-toolbar-title class="font-weight-bold" style="color: var(--v-grey-500-base)">{{
        isPreferences ? 'Preferences' : 'Notifications'
      }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn v-if="!insideNav" small text color="primary" @click="markALlAsRead">
        Mark all as read
      </v-btn>

      <v-btn v-if="!insideNav" small text color="error" @click="clearAllNotifications">
        Clear All
      </v-btn>

      <v-btn icon @click="openPreferences()">
        <v-icon :color="insideNav ? 'mid-grey' : 'primary'">mdi-cog</v-icon>
      </v-btn>
    </v-app-bar>

    <v-sheet class="d-flex justify-center" v-if="insideNav" color="bg_Greeny_Gray">
      <v-btn small text color="primary" @click="markALlAsRead"> Mark all as read </v-btn>

      <v-btn small text color="error" @click="clearAllNotifications"> Clear All </v-btn>
    </v-sheet>

    <v-list
      v-if="!isPreferences"
      :color="insideNav ? 'bg_Greeny_Gray' : 'kanban_card_bg_color'"
      class="overflow-y-auto"
      :max-height="!insideNav ? 500 : '70vh'"
      scroll-target="#notification-list">
      <template v-for="(notification, index) in userNotifications">
        <v-list-item
          class="notificationCard"
          :class="{ 'ms-4 me-3 mb-2 rounded px-2': insideNav }"
          :style="{
            border: insideNav ? '1px solid  var(--v-mid-grey-lighten4)' : 'none',
            backgroundColor: notification.read
              ? 'var(--v-kanban_card_bg_color-base)'
              : 'var(--v-bg_highlight-base)',
          }"
          :key="notification.id">
          <v-tooltip left class="custom-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small icon class="notificationDot" @click.stop="markAsRead_UnRead(notification)">
                <v-icon :x-small="notification.read" color="primary" v-bind="attrs" v-on="on"
                  >{{ notification.read ? 'mdi-circle-outline' : 'mdi-circle-medium' }}
                </v-icon>
              </v-btn>
            </template>
            <span class="text-caption">
              {{ notification.read ? 'Mark as unread' : 'Mark as read' }}</span
            >
          </v-tooltip>

          <v-list-item-avatar :size="insideNav ? '30' : '40'" :class="{ 'me-2': insideNav }">
            <v-icon :class="getNotificationIconClass(notification)" size="20"> {{ getNotificationIcon(notification) }} </v-icon>
          </v-list-item-avatar>

          <v-list-item-content :class="{ 'ms-2': !insideNav }">
            <v-list-item-title
              style="color: var(--v-grey-500-base)"
              class="font-weight-medium mt-3"
              :class="{ 'text-subtitle-2': insideNav }"
              >{{ getNotificationMessage(notification) }}</v-list-item-title
            >

            <div class="d-flex justify-space-between align-center">
              <v-list-item-subtitle
                :class="{ 'text-caption': insideNav }"
                style="color: var(--v-grey-500-lighten1); font-size: 0.65rem !important"
                >{{ formattedDate(notification.createDate) }}</v-list-item-subtitle
              >
              <v-btn
                class="transparent-btn font-weight-bold"
                text
                :small="insideNav ? false : true"
                :x-small="insideNav ? true : false"
                depressed
                :ripple="false"
                color="primary"
                @click.stop="navigatToNotification(notification)">
                Show Details
              </v-btn>
            </div>
          </v-list-item-content>

          <!-- <v-list-item-action class="my-0 align-self-end"> </v-list-item-action> -->
        </v-list-item>
        <v-divider
          v-if="index < userNotifications.length - 1 && !insideNav"
          :key="index"></v-divider>
      </template>
    </v-list>
    <div class="d-flex pa-3 overflow-y-auto" v-else>
      <v-expansion-panels
        accordion
        flat
        :style="{ maxheight: insideNav ? '70vh' : '40vh' }"
        multiple
        v-model="expandedPanels">
        <v-expansion-panel v-for="(medium, i) in NotificationMedium" :key="i">
          <v-expansion-panel-header class="py-0 px-2" @click="togglePanel(i)">
            <template v-slot:actions>
              <v-switch
                class="ma-0"
                inset
                hide-details
                :ripple="false"
                color="primary"
                dense
                v-model="medium.enabled"
                @click="togglePanel(i)"></v-switch>
            </template>
            <span class="mx-2">{{ medium.name }}</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container class="px-1">
              <v-row
                v-for="(preference, key) in notificationPreferences.filter(
                  (obj) => obj.medium === medium.id,
                )"
                :key="key">
                <v-col cols="12" class="pa-0">
                  <v-checkbox
                    hide-details
                    @change="checkSwitcher"
                    v-model="preference.enabled"
                    :label="convertString(preference.type)">
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <v-sheet
      v-if="!userNotifications.length && !isPreferences"
      class="d-flex justify-center align-center flex-column flex-grow-1"
      :color="insideNav ? 'bg_Greeny_Gray' : 'kanban_card_bg_color'">
      <v-img max-height="200" max-width="200" src="@Assets/svgs/notification_sleep.svg"></v-img>
      <v-card-title class="font-weight-bold">No Notifications Yet</v-card-title>
      <v-card-subtitle class="text-center"
        >You have no notifications now. <br />
        Come back later</v-card-subtitle
      >
    </v-sheet>
    <v-spacer v-if="isPreferences"></v-spacer>
    <v-card-actions v-if="isPreferences" class="pt-2 d-flex" :class="{ 'justify-end': !insideNav }">
      <v-btn color="primary" :block="insideNav ? true : false" @click="saveChanges()">
        Save Changes
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { log, warn, error } from '@/utils/debugLogger';
  import moment from 'moment';
  import { NotificationType } from '@Share/config/enums';
  export default {
    name: 'SystemNotifications',
    data() {
      return {
        isPreferences: false,
        expandedPanels: [],
        NotificationMedium: [
          {
            id: 1,
            name: 'Email',
            enabled: false,
          },
          {
            id: 2,
            name: 'System',
            enabled: false,
          },
        ],
        NotificationType,
      };
    },
    props: {
      isMenuClosed: {
        type: Boolean,
        default: false,
      },
      insideNav: {
        type: Boolean,
        default: false,
      },
    },
    components: {},
    computed: {
      formattedDate() {
        return (date) => {
          return moment(date).format('YYYY-MM-DD HH:mm');
        };
      },
      notificationPreferences() {
        return this.$store.getters['NOTIFICATIONS/GET_NOTIFICATION_PREFERENCES'];
      },
      userNotifications() {
        return this.$store.getters['NOTIFICATIONS/GET_USER_NOTIFICATIONS'];
      },
    },
    methods: {
      convertString(type) {
        if (this.NotificationType.TaskAssigned == type) {
          return 'Task Assigned';
        } else if (this.NotificationType.ApiDataPullCompleted == type) {
          return 'API Data Pull Completed';
        } else if (this.NotificationType.ApiDataPullFailed == type) {
          return 'API Data Pull Failed';
        } else if (this.NotificationType.ReleasePublished == type) {
          return 'Release Published';
        } else {
          return '';
        }
      },
      getNotificationMessage(notification) {
        if (!notification || !notification.body) return 'No message';
        const body = notification.body;
        // Release notifications carry the release itself rather than a prepared message string.
        if (notification.type === this.NotificationType.ReleasePublished) {
          const release = this.releaseNotificationBody(notification);
          const name = release.name || release.Name;
          if (name) return `New release: ${name}`;
        }
        // Check outer body first, then inner nested body (may be string or object)
        if (body.Message || body.message) return body.Message || body.message;
        if (typeof body.body === 'string') {
          try { return JSON.parse(body.body).message || 'No message'; } catch (err) { /* fall through */ }
        } else if (body.body && (body.body.Message || body.body.message)) {
          return body.body.Message || body.body.message;
        }
        return 'No message';
      },
      getNotificationIcon(notification) {
        if (!notification) return 'mdi-bell-ring-outline';
        switch (notification.type) {
          case this.NotificationType.ApiDataPullCompleted:
            return 'mdi-database-check-outline';
          case this.NotificationType.ApiDataPullFailed:
            return 'mdi-database-alert-outline';
          case this.NotificationType.ReleasePublished:
            return 'mdi-bullhorn-outline';
          default:
            return 'mdi-bell-ring-outline';
        }
      },
      getNotificationIconClass(notification) {
        if (!notification) return 'bg1';
        switch (notification.type) {
          case this.NotificationType.ApiDataPullFailed:
            return 'error';
          default:
            return 'bg1';
        }
      },
      togglePanel(index) {
        // this.expandedPanels = Array(2).fill(false);
        this.$set(this.expandedPanels, index, !this.expandedPanels[index]);
      },
      resetPreferences() {
        this.isPreferences = false;
        this.expandedPanels = [];
        this.$store.dispatch('NOTIFICATIONS/GET_USER_NOTIFICATIONS');
      },
      closeNotifications() {
        this.$emit('showNotifications', false);
      },
      openPreferences() {
        this.isPreferences = true;
        this.$store.dispatch('NOTIFICATIONS/GET_PREFERENCES');
      },
      saveChanges() {
        this.$store.dispatch('NOTIFICATIONS/UPDATE_PREFERENCES', this.notificationPreferences);
        this.resetPreferences();
      },
      navigatToNotification(notiification) {
        log('navigatToNotification', notiification);
        this.markAsRead(notiification);

        switch (notiification.type) {
          case this.NotificationType.TaskAssigned:
            this.handleTaskAssigned(notiification);
            break;
          case this.NotificationType.TagImportCompleted:
            this.handleTagImportCompleted(notiification);
            break;
          case this.NotificationType.ApiDataPullCompleted:
          case this.NotificationType.ApiDataPullFailed:
            this.handleApiDataPullNotification(notiification);
            break;
          case this.NotificationType.ReleasePublished:
            this.handleReleasePublished(notiification);
            break;
          default:
            break;
        }
      },
      /**
       * The notification body may arrive with the inner payload still JSON-encoded (as it does for
       * API data pulls), so unwrap it the same way before reading the release fields.
       */
      releaseNotificationBody(notification) {
        let body = (notification && notification.body) || {};
        if (typeof body.body === 'string') {
          try { body = JSON.parse(body.body); } catch (err) { /* use outer body */ }
        } else if (body.body && typeof body.body === 'object') {
          body = body.body;
        }
        return body || {};
      },
      handleReleasePublished(notification) {
        const body = this.releaseNotificationBody(notification);
        const slug = body.slug || body.Slug;
        if (!slug) return;
        this.$router.push({ name: 'release-detail-public', params: { slug } }).catch(() => {});
      },
      handleTagImportCompleted() {
        this.$store.dispatch('GET_MASTERS_STATUS');
        this.$router.push({ name: 'tagHarvesters'})
      },
      handleApiDataPullNotification(notification) {
        let body = notification.body || {};
        // When loaded from API, the inner body may still be a JSON string
        if (typeof body.body === 'string') {
          try { body = JSON.parse(body.body); } catch (err) { /* use outer body */ }
        } else if (typeof body.body === 'object' && body.body !== null) {
          body = body.body;
        }
        this.$router.push({
          name: 'RegistersAdmin',
          query: {
            registerId: body.RegisterId,
            dataSourceId: body.DataSourceId,
            view: 'history',
          },
        });
      },
      handleTaskAssigned(notification) {
        let path = `/${this.$route.params.id}/${notification.body.TypeId}`;
        this.$route.query.TaskId = notification.body.TaskId;
        this.$router.push({ path: path, query: { taskId: notification.body.TaskId } });
      },
      checkSwitcher() {
        for (let index = 0; index < this.NotificationMedium.length; index++) {
          let specificMediumArr = this.notificationPreferences.filter(
            (element) => element.medium === this.NotificationMedium[index].id,
          );
          const allDisabled = specificMediumArr.every((item) => item.enabled === false);
          if (allDisabled) {
            this.NotificationMedium[index].enabled = false;
          } else {
            this.NotificationMedium[index].enabled = true;
          }
        }
      },
      clearAllNotifications() {
        this.$dialog.error({
          text: 'Are you sure you want to clear all notifications?',
          title: 'Clear Notifications',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                this.$store.dispatch('NOTIFICATIONS/CLEAR_ALL');
              },
            },
          },
        });
      },
      markALlAsRead() {
        this.$store.dispatch('NOTIFICATIONS/MARK_ALL_AS_READ');
      },
      markAsRead_UnRead(notification) {
        let data = { id: notification.id, value: notification.read ? false : true };
        this.$store.dispatch('NOTIFICATIONS/MARK_READ_UNREAD', data);
      },
      markAsRead(notification) {
        if (notification.read) return;
        let data = { id: notification.id, value: true };
        this.$store.dispatch('NOTIFICATIONS/MARK_READ_UNREAD', data);
      },
    },
    created() {
      this.$store.dispatch('NOTIFICATIONS/GET_USER_NOTIFICATIONS');
      this.$store.commit('TASK/SET_ROUTE_TO_PATH_FIRED', false);
    },
    watch: {
      isMenuClosed: {
        handler: function (newValue) {
          if (newValue) {
            this.resetPreferences();
          }
        },
        deep: true,
      },
      notificationPreferences: {
        handler: function () {
          for (let index = 0; index < this.NotificationMedium.length; index++) {
            this.notificationPreferences.forEach((pref) => {
              if (pref.medium === this.NotificationMedium[index].id && pref.enabled === true) {
                this.NotificationMedium[index].enabled = true;
                if (!this.expandedPanels.includes(index)) this.expandedPanels.push(index);
              }
            });
          }
        },
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .transparent-btn {
    background-color: transparent;
    color: var(--v-bg_force_white-base); /* Make the text white */

    &:hover::before,
    &:focus::before,
    &:active::before {
      background-color: transparent;
    }

    &:focus,
    &:active {
      background-color: transparent;
    }
    &::before {
      background-color: transparent;
    }
  }
  .v-expansion-panel {
    margin-bottom: 10px;
    .v-expansion-panel-header,
    .v-expansion-panel-content {
      border-right: 1px solid var(--v-light-grey-base);
      border-left: 1px solid var(--v-light-grey-base);
    }
    .v-expansion-panel-header {
      border-top: 1px solid var(--v-light-grey-base);
      border-bottom: 1px solid var(--v-light-grey-base);
    }
    .v-expansion-panel-header--active {
      border-bottom: none;
    }
    .v-expansion-panel-content {
      border-bottom: 1px solid var(--v-light-grey-base);
    }
  }
  .notificationCard {
    position: relative;
    cursor: default;
    &::before {
      pointer-events: none;
    }
    .notificationDot {
      position: absolute;
      top: 0;
      right: 2px;
      z-index: 2;
    }
    .transparent-btn {
      z-index: 2;
    }
  }

  .v-tooltip__content {
    background-color: var(--v-mid-grey-base);
    color: #fff;
    border-radius: 3px;
    padding: 3px 5px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  }
</style>
